'use client'

import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import LineStroke from "../individual-components/line-stroke";
import ArrowSvg from "../individual-components/arrow-svg";
import SliderData from "@/assets/data/ambassadors.json"
import Image from "next/legacy/image";

function Ambassadors({ context }) {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const sliderRef1 = useRef(null);
    const sliderRef2 = useRef(null);

    useEffect(() => {
        setNav1(sliderRef1.current);
        setNav2(sliderRef2.current);
    }, []);

    return (
        SliderData?.length ?
            <section className="relative z-10 w-full px-4 mx-auto mb-16 md:mb-20 xl:px-2">
                <div className="max-w-7xl mx-auto relative min-h-[450px]">
                    <div className="w-56 sm:w-full mx-auto mb-5">
                        <LineStroke />
                    </div>

                    <div className="md:text-[32px] xs:text-2xl md:leading-10 text-center mx-auto text-3xl leading-none max-w-3xl md:mb-4 mb-3 font-bold">
                        {context?.header}
                    </div>

                    <p className="md:text-xl text-lg text-center text-secondary max-w-3xl mx-auto md:mb-10 mb-10 last:mb-0 ">
                        {context?.description}
                    </p>

                    <div className="relative max-w-[95%] md:mx-auto overflow-hidden">
                        <Slider asNavFor={nav2} autoplay autoplaySpeed={5000} ref={sliderRef1}>
                            {SliderData?.map((item, index) => (
                                <section key={item?.name}>
                                    <div className="relative px-5 cursor-grab w-full flex md:flex-col-reverse md:gap-10 gap-16 items-center justify-center">
                                        <div className="w-full flex flex-col h-full text-center gap-2">
                                            <div className="text-[30px] font-semibold">{item?.name}</div>
                                            <div className="text-base text-secondary">{item?.location}</div>
                                            <div className="text-lg text-secondary md:mb-8 mb-10">{item?.role}</div>
                                            <div className="relative mb-4 w-full max-w-[200px] mx-auto">
                                                <LineStroke />
                                            </div>
                                            <div className="relative w-full text-lg leading-8">
                                                {item.quote}
                                            </div>
                                        </div>
                                        <div className=" bg-gradient-to-r from-white to-[#EB532E] pl-2 pt-2 pr-2 pb-0 flex-none rounded-full ">
                                            <Image
                                                src={item.imageSrc}
                                                className="overflow-hidden rounded-full object-cover"
                                                alt={`${item.name}`}
                                                layout="intrinsic"
                                                width={300}
                                                height={300}
                                            />
                                        </div>

                                    </div>
                                </section>
                            ))}
                        </Slider>
                    </div>

                    <div className="relative max-w-[15rem] sm:px-5 mx-auto mt-12 sm:mt-0 cursor-grab">
                        <Slider
                            asNavFor={nav1}
                            ref={sliderRef2}
                            slidesToShow={3}
                            swipeToSlide={true}
                            focusOnSelect={true}
                            // prevArrow={<ArrowSvg direction='prev' />}
                            // nextArrow={<ArrowSvg direction='next' />}
                        >
                            {SliderData?.map((item, index) => (
                                <div key={item?.name}>
                                    <img
                                        className="w-12 h-12 cursor-pointer mx-auto bg-gradient-to-r from-white to-[#EB532E] p-0.5 flex-none rounded-full object-cover"
                                        src={item?.imageSrc}
                                        alt={`${item?.name}`}
                                    />
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </section>
            : null
    );
}

export default Ambassadors;
